interface Character {
  id: string;
  name: string;
  size: number;
  svgUrl: string;
  svgUrlFail: string;
}
export const carrierRules = (platform: Character[]): string => {
    const hasWolf = platform.some(char => char.name === "wolf");
    const hasGoat = platform.some(char => char.name === "goat");
    const hasCabbage = platform.some(char => char.name === "cabbage");
    
    // Нельзя оставлять волка с козой без перевозчика
    if (hasWolf && hasGoat && platform.length === 2) {
      return "overGoat";
    }
    
    // Нельзя оставлять козу с капустой без перевозчика
    if (hasGoat && hasCabbage && platform.length === 2) {
      return "overCabbage";
    }
    
    return "true";
  };

